//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from "vuex";
import UserAccount from "@/components/UserAccount/UserAccount.vue";
import AQTooltip from "@/components/Generics/AQTooltip/AQTooltip.vue";
import FabHeaderMenuActions from "@/pages/fabricInterface/components/FabHeaderMenuActions.vue";
import ErrorsIcon from "@/assets/images/TaskErrorsIcon.svg";
import ErrorsIconHover from "@/assets/images/TaskErrorsIconHover.svg";
import MobileHeader from "@/components/Mobile/MobileHeader.vue";
import HelpCenter from "@/components/HelpCenter/HelpCenter.vue";

const checkClipping = (el) => el && (el.scrollWidth > el.clientWidth);

export default {
    name: "FabHeaderMenu",
    components: {
        FabHeaderMenuActions,
        AQTooltip,
        UserAccount,
        MobileHeader,
        HelpCenter
    },
    props: {
        title: { type: String, default: "" },
        isExternal: { type: Boolean, default: false },
        showErrors: { type: Boolean, default: false },
        invalidFields: { type: Array, default: () => [] },
        showActions: { type: Boolean, required: true },
        isOwner: { type: Boolean, default: false },
        sideBarPermissions: { type: Object, default: () => {} }
    },
    data() {
        return {
            showJiraSupport: false,
            helpCenterModel: false,
            showHeaderTooltip: false,
            hoverIcon: false,
            taskErrorsIcon: `img:${ErrorsIcon}`,
            taskErrorsIconHover: `img:${ErrorsIconHover}`
        };
    },
    computed: {
        ...mapState("components", ["isSmallScreen"]),
        ...mapState("apps", ["userSystemPermissions"]),
        ...mapState("userProfile", ["needsTaskRedirect"]),
        isWebHelpCompliant() {
            const permissions = this.userSystemPermissions || {};
            return (permissions.A && permissions.A.g) || (permissions.C && permissions.C.g);
        },
        errorsIcon() {
            return this.hoverIcon ? this.taskErrorsIconHover : this.taskErrorsIcon;
        }
    },
    beforeMount() {
        const originList = (process.env.VUE_APP_ORIGIN || "").split(",");
        this.showJiraSupport = originList.includes(window.location.host);
    },
    mounted() {
        this.checkHeaderEllipsis();
    },
    methods: {
        onAction(actionType) {
            this.$emit("fabAction", actionType);
        },
        goToHelp() {
            this.helpCenterModel = true;
        },
        checkHeaderEllipsis() {
            const { header } = this.$refs;
            this.showHeaderTooltip = checkClipping(header);
        },
        onClickCancel(ev) {
            this.$emit("action", { trigger: "cancel", ev });
        },
        onClickSupport() {
            const ifr = document.getElementById("jsd-widget");
            const ifrDoc = ifr && ifr.contentWindow.document;
            const button = ifrDoc && ifrDoc.getElementById("help-button");

            if (ifr && ifrDoc && button) {
                if (!ifr.classList.contains("init")) {
                    const css = document.createElement("style");
                    css.type = "text/css";
                    css.appendChild(document.createTextNode("#help-button{display:none};"));

                    ifrDoc.getElementsByTagName("head")[0].appendChild(css);
                    ifr.classList.add("init");
                }

                button.click();
                this.waitForLoading(ifrDoc);
            }
        },
        waitForLoading(ifrDoc) {
            const popup = ifrDoc.getElementById("widget-header");
            if (popup) {
                const submitButton = ifrDoc.getElementById("submit-button");
                const groups = ifrDoc.getElementsByClassName("ak-field-group");
                const trans = ["Sumar", "Prioritate", "Componenta", "Descriere", "Atasament", "Adresa de e-mail"];
                const component = { platform: 10194, portal: 10193 };
                Array.from(groups).forEach((el, idx) => {
                    if (idx === 2) {
                        const select = el.getElementsByTagName("div")[0];
                        const input = document.createElement("input");
                        el.style.display = "none";
                        input.type = "hidden";
                        input.name = "components[][id]";
                        input.value = component.platform;
                        select.prepend(input);
                    } else {
                        if (idx === 0) { el.style.paddingTop = 0; }
                        const span = el.getElementsByTagName("span")[0];
                        span.innerText = trans[idx];
                    }
                });
                submitButton.innerText = "Trimite";
                popup.getElementsByClassName("header-text")[0].innerText = "Ajutor";
            } else {
                window.setTimeout(() => {
                    this.waitForLoading(ifrDoc);
                }, 1);
            }
        }
    }
};
